/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */

// Defines the events to be used for analytics, with Amplitude.
export const AnalyticsEvents = {
  PLAYGROUND: {
    NewPGNavigation: 'NewPGNavigation',
    NewPGHeader: 'NewPGHeader',
    PGHistoryButtonOpen: 'PGHistoryButtonOpen',
    PGHistoryButtonClose: 'PGHistoryButtonClose',
    PGKonciergeButtonOpen: 'PGKonciergeButtonOpen',
    PGKonciergeButtonClose: 'PGKonciergeButtonClose',
    PGRestartButton: 'PGRestartButton',
    PGStartAtLineButton: 'PGStartAtLineButtonClick',
    PGPauseAtLineButton: 'PGPauseAtLineButtonClick'
  },
  EXCEPTION_CENTER: {
    ClickQuestionSubmit: 'ClickQuestionSubmit'
  },
  PROCESS: {
    ProcessesPage: 'ProcessesPage',
    ClickNewProcedure: 'ClickNewProcedure',
    ProcedureUpdated: 'ProcedureUpdated',
    ProcedureCreated: 'ProcedureCreated'
  },
  LOGIN: {
    LoginVerificationPage: 'LoginVerificationPage',
    LoginPage: 'LoginPage'
  },
  ORGANIZATION: {
    CreateOrganizationSuccess: 'CreateOrganizationSuccess',
    CreateOrganizationFail: 'CreateOrganizationFail'
  },
  RETRY: {
    ClickRunAgainButton: 'ClickRunAgainButton'
  }
};
